<template>
    <section class="content">
        <div class="container-fluid">
            <div class="block-header">
                <h2>{{ nama }}</h2>
            </div>
            <div class="row clearfix">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card">
                        <div class="header">
                            <h2>
                                {{ id != null ? 'Edit' : 'Tambah' }} {{ nama }}
                            </h2>
                        </div>
                        <div class="body">
                            <form class="form-horizontal" v-on:submit.prevent="onSubmit">
                                <div class='row clearfix'>
                                 <div
                                   class='col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label'
                                 >
                                   <label for='title'>Title</label>
                                 </div>
                                 <div class='col-lg-10 col-md-10 col-sm-8 col-xs-7'>
                                   <div class='form-group'>
                                     <form-line
                                       id='title'
                                       type='text'
                                       v-model='content.title'
                                     ></form-line>
                                   </div>
                                 </div>
                               </div>
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="deskripsi">Deskripsi</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <Ckeditor id="deskripsi" v-model="content.content" :config="config"></Ckeditor>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                        <button v-if="id != null" @click="update" type="button" class="btn btn-warning waves-effect waves-button" v-bind:disabled="isLoading" v-waves.button><i v-if="isLoading" class="fa fa-spin fa-spinner"></i><i v-if="!isLoading" class="material-icons">save</i> Edit</button>
                                        <button v-else @click="save" type="button" class="btn btn-primary waves-effect waves-button" v-bind:disabled="isLoading" v-waves.button><i v-if="isLoading" class="fa fa-spin fa-spinner"></i><i v-if="!isLoading" class="material-icons">save</i> Simpan</button>
                                        <button @click="$router.go(-1)" type="button" class="btn btn-danger" v-waves.button><i class="material-icons">cancel</i> Batal</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
/* eslint-disable */

  import Ckeditor from 'vue-ckeditor2'
  import FormLine from '@/components/FormLine.vue'
  import api from '@/helper/api'

  export default {
    components: {FormLine, Ckeditor},
    name: 'HakdanKewajiban',
    data: function () {
      return {
        config: {
          toolbar: [
            { name: 'stuff', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
            { name: 'morestuff', items: ['NumberedList', 'BulletedList'] },

            { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'] },
            { name: 'colors', items: ['TextColor'] },
            { name: 'paragraph2', items: ['JustifyLeft', 'JustiftyCenter', 'JustifyRight', 'Outdent', 'Indent'] },
            '/',
            { name: 'document', items: ['Source'] }
          ],
          height: 300
        },
        content: {
          title :'',
          content: ''
        },
        tanggal: '',
        id: '',
        nama: '',
        tipe: '',
        link: '',
        isLoading: false,
        init: false
      }
    },
    methods: {
      save () {
        this.isLoading = true
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.post('/createHakDanKewajiban', this.content).then((result) => {
          if (result.data.code === 200) {
            this.$toastr.s('Tambah data berhasil')
            this.$router.replace('/main/HakdanWajiban/ListHakdanKewajiban')
            location.reload()
          } else {
            var msg = 'Tambah data gagal'
            if (result.data.message !== '') msg = result.data.message
            this.$toastr.e(msg)
          }
          this.isLoading = false
        }).catch(e => {
          var msg = 'Terjadi kesalahan pada server, mohon ulangi'
          if (e.response.data.message) msg = e.response.data.message
          this.$toastr.e(msg)
          this.isLoading = false
        })
      },
      update () {
        this.isLoading = true
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.post('/updateHakdanKewajiban/' + this.id, this.content).then((result) => {
          if (result.data.code === 200) {
            this.$router.replace('/main/HakdanWajiban/' + this.link)
            this.$toastr.s('Ubah data berhasil')
          }
          this.isLoading = false
        }).catch(e => {
          var msg = 'Terjadi kesalahan pada server, mohon ulangi'
          if (e.response.data.message) msg = e.response.data.message
          this.$toastr.e(msg)
          this.isLoading = false
        })
      },
      getDetail () {
        this.init = true
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.get('/getHakDanKewajiban/' + this.id).then((result) => {
          this.content = result.data.object
          this.tanggal = this.$moment(this.content.tanggal, 'YYYY-MM-DD').format('DD-MM-YYYY')
          this.init = false
        }).catch((ex) => {
          this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi')
          this.init = false
        })
      },
      sendingEvent (file, xhr, formData) {
        console.log(this.id)
        formData.append('id', parseInt(this.id))
      },
      onSubmit () {
        if (this.id != null) this.update()
        else this.save()
      },
      checkRoute (route) {
        console.log(route.name)
        if (route.name === 'EditHakKewajiban') {
          this.link = 'ListHakdanKewajiban'
          this.nama = 'ListHakdanKewajiban'
        }
      },
      vremoved (file, xhr, error) {
        console.log(file)
        if (!this.init) this.delete(file.id)
      },
      delete (id) {
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.delete('/deleteHakdanKewajiban/' + id).then((result) => {
          this.$toastr.s('Foto berhasil dihapus')
          this.getData()
          this.$swal.close()
        }).catch(e => {
          this.getData()
          this.$swal.close()
        })
      }
    },
    mounted () {
      this.checkRoute(this.$route)
      this.id = this.$route.params.id
      if (this.id != null) {
        this.getDetail()
      }
    },
    watch: {
      '$route' (to, from) {
        this.checkRoute(to)
        this.getData()
      },
      tanggal: function (val) {
        this.content.tanggal = this.$moment(val, 'DD-MM-YYYY').format('YYYY-MM-DD')
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/view/HakdanKewajiban/FormHakdanKewajiban.vue